module.exports = __webpack_public_path__ + "img/download-audio-light.e599709d.png";